#@export GliveBooking.Presenters.Calendar

class GliveBooking.Presenters.Calendar extends BookingV2.Presenters.Calendar

  toHash: ->
    hash = BookingV2.Presenters.Calendar.prototype.toHash.apply(this, arguments)
    hash.isTouch = @collection.meta('isTouch')
    hash.year = @options.calendarData.year
    hash
